import React from 'react';

function FullScreen() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" className="display-block">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g
          fill="currentColor"
          fillRule="nonzero"
          transform="translate(-1249 -1008)"
        >
          <g transform="translate(1235 994)">
            <path d="M25.09 21a.91.91 0 01.91.91v2.726C26 25.39 25.39 26 24.636 26H21.91a.91.91 0 010-1.818h2.046a.227.227 0 00.227-.227v-2.046A.91.91 0 0125.09 21zm-10.18 0a.91.91 0 01.908.91v2.045c0 .125.102.227.227.227h2.046a.91.91 0 110 1.818h-2.727C14.61 26 14 25.39 14 24.636V21.91a.91.91 0 01.91-.909zm3.18-7a.91.91 0 010 1.818h-2.045a.227.227 0 00-.227.227v2.046a.91.91 0 11-1.818 0v-2.727c0-.753.61-1.364 1.364-1.364h2.727zm6.546 0c.753 0 1.364.61 1.364 1.364v2.727a.91.91 0 01-1.818 0v-2.046a.227.227 0 00-.227-.227h-2.046a.91.91 0 110-1.818h2.727z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FullScreen;



// WEBPACK FOOTER //
// ./src/components/icons/FullScreen/index.js